import { Box, Skeleton, TableCell, TableRow } from "@mui/material";
import { ComplianceTable } from "~/components/Completion/ComplianceTable";
import { ChecksOrderField } from "~/operations";

export const ComplianceControlChecksSkeleton = () => {
  return (
    <ComplianceTable
      tableHeaders={[
        { id: "SELECT", label: "", sortable: false },
        { id: "IMPACT", label: "Impact", sortable: false },
        { id: "NAME", label: "Check / Policy" },
        { id: "ASSETS_COUNT", label: "Assets" },
        { id: "COMPLETION", label: "Completion", sortable: true },
      ]}
      defaultActiveColumn={ChecksOrderField.Name}
    >
      {Array.from({ length: 10 }).map((_, index) => (
        <TableRow key={index}>
          <TableCell>
            <Skeleton
              variant="rectangular"
              width={24}
              height={24}
              animation="wave"
            />
          </TableCell>
          <TableCell>
            <Skeleton
              variant="circular"
              width={32}
              height={32}
              animation="wave"
            />
          </TableCell>
          <TableCell>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              <Skeleton
                variant="text"
                width="70%"
                height={20}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="40%"
                height={12}
                animation="wave"
              />
            </Box>
          </TableCell>
          <TableCell>
            <Skeleton variant="text" width={40} height={20} animation="wave" />
          </TableCell>
          <TableCell>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={16}
              animation="wave"
            />
          </TableCell>
        </TableRow>
      ))}
    </ComplianceTable>
  );
};
